import { Calculator } from "./Calculator"
import s from "./Settings.module.css"
import { PriceType, SHOP_IDENT } from "../../app/reducers/settingsReducer"
import { TextField, Box, Button, Flex } from "@radix-ui/themes"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { selectShopsStore } from "../../app/reducers/shopsSlice"
import { updateShopCalcIdent } from "../../app/reducers/shopsSlice"
import { selectFeedShopsStore } from "../../app/reducers/feedShopsSlice"
import { Cross1Icon, PlusIcon } from "@radix-ui/react-icons"
import { Select } from "../Select/Select"

const CALC_OPTIONS = [
  { value: "default1", label: "ДОХОД" },
  { value: "default2", label: "ДОХОД - РАСХОД" },
  { value: "with_sizes_1", label: "С размерами" },
  { value: "ozon", label: "Озон" },
  { value: "yandex", label: "Яндекс" },
]

type IPriceSettingProps = PriceType & {
  onSave: (
    args: PriceType,
    amountParams?: { count: number; amount: number }[],
  ) => void
  shop: SHOP_IDENT
  onChange: (
    args: PriceType,
    amountParams?: { count: number; amount: number }[],
  ) => void
  amountParams: {
    count: number
    amount: number
  }[]
}

export const PriceSetting = (props: IPriceSettingProps) => {
  const { onSave, onChange, shop, amountParams, ...priceParams } = props
  const dispatch = useAppDispatch()
  const shops = useAppSelector(selectShopsStore)
  const feedShops = useAppSelector(selectFeedShopsStore)

  const calcIdent =
    shops?.[shop]?.calcIdent || feedShops?.[shop]?.calcIdent || ""
  const isFeedShop = !!feedShops?.[shop]

  return (
    <Box className={s.priceSetting} pr="4">
      <div>
        <div className={s.inputWrap}>
          <label htmlFor="calcIdent">Калькулятор</label>
          <Select
            value={calcIdent || "default1"}
            onChange={(ident) => {
              dispatch(
                updateShopCalcIdent({ shop, calcIdent: ident, isFeedShop }),
              )
            }}
            options={CALC_OPTIONS}
            size="3"
          />
        </div>
        <h5>Изменение параметров цены</h5>
        <div>
          <div className={s.inputWrap}>
            <label htmlFor="margin">Маржинальность</label>
            <TextField.Root
              size="3"
              value={priceParams.margin}
              onChange={(e) =>
                onChange({
                  ...priceParams,
                  margin: Number(e.target.value),
                })
              }
              name="margin"
              type="number"
              min="0"
            />
          </div>
          <div className={s.inputWrap}>
            <label htmlFor="profit">Минимальная прибль</label>
            <TextField.Root
              size="3"
              value={priceParams.profit}
              onChange={(e) =>
                onChange({
                  ...priceParams,
                  profit: Number(e.target.value),
                })
              }
              name="profit"
              type="number"
              min="0"
            />
          </div>
          {["SAMSON"].includes(shop) || ["with_sizes_1"].includes(calcIdent) ? (
            <>
              <div className={s.inputWrap}>
                <label htmlFor="liter_price">Цена за первый литр</label>
                <TextField.Root
                  size="3"
                  value={priceParams.liter_price}
                  onChange={(e) =>
                    onChange({
                      ...priceParams,
                      liter_price: Number(e.target.value),
                    })
                  }
                  name="liter_price"
                  type="number"
                  min={0}
                />
              </div>
              <div className={s.inputWrap}>
                <label htmlFor="extra_liter_price">
                  Цена за последующие литры
                </label>
                <TextField.Root
                  size="3"
                  value={priceParams.extra_liter_price}
                  onChange={(e) =>
                    onChange({
                      ...priceParams,
                      extra_liter_price: Number(e.target.value),
                    })
                  }
                  name="extra_liter_price"
                  type="number"
                  min={0}
                />
              </div>
            </>
          ) : (
            <div className={s.inputWrap}>
              <label htmlFor="logistic">Логистика</label>
              <TextField.Root
                size="3"
                value={priceParams.logistic}
                onChange={(e) =>
                  onChange({
                    ...priceParams,
                    logistic: Number(e.target.value),
                  })
                }
                name="logistic"
                type="number"
                min="0"
              />
            </div>
          )}
          <div className={s.inputWrap}>
            <label htmlFor="ff">ФФ</label>
            <TextField.Root
              size="3"
              value={priceParams.ff}
              onChange={(e) =>
                onChange({
                  ...priceParams,
                  ff: Number(e.target.value),
                })
              }
              name="ff"
              type="number"
              min="0"
            />
          </div>
          <div className={s.inputWrap}>
            <label htmlFor="coef">Комиссия%</label>
            <TextField.Root
              size="3"
              value={priceParams.coef}
              onChange={(e) =>
                onChange({
                  ...priceParams,
                  coef: Number(e.target.value),
                })
              }
              name="coef"
              type="number"
              min="0"
            />
          </div>
          <div className={s.inputWrap}>
            <label htmlFor="tax">Налог</label>
            <TextField.Root
              size="3"
              value={priceParams.tax}
              onChange={(e) =>
                onChange({
                  ...priceParams,
                  tax: Number(e.target.value),
                })
              }
              name="tax"
              type="number"
              min="0"
            />
          </div>
          <div className={s.inputWrap}>
            <label htmlFor="sale">Скидка</label>
            <TextField.Root
              size="3"
              value={priceParams.sale}
              onChange={(e) =>
                onChange({
                  ...priceParams,
                  sale:
                    e.target.value === ""
                      ? undefined
                      : Math.min(Number(e.target.value), 0.99),
                })
              }
              name="sale"
              type="number"
              min={0}
            />
          </div>
          {[
            SHOP_IDENT.KATREN_OZON,
            SHOP_IDENT.KATREN_YANDEX,
            SHOP_IDENT.SAMSON_YANDEX,
          ].includes(shop) && (
            <>
              <div className={s.inputWrap}>
                <label htmlFor="priemka">Приемка-обработка</label>
                <TextField.Root
                  size="3"
                  value={priceParams.priemka}
                  onChange={(e) =>
                    onChange({
                      ...priceParams,
                      priemka: Number(e.target.value),
                    })
                  }
                  name="priemka"
                  type="number"
                  min={0}
                />
              </div>
              <div className={s.inputWrap}>
                <label htmlFor="ekv">Эквайринг</label>
                <TextField.Root
                  size="3"
                  value={priceParams.ekv}
                  onChange={(e) =>
                    onChange({
                      ...priceParams,
                      ekv: Number(e.target.value),
                    })
                  }
                  name="ekv"
                  type="number"
                  min={0}
                />
              </div>
              {[SHOP_IDENT.KATREN_OZON].includes(shop) && (
                <div className={s.inputWrap}>
                  <label htmlFor="mila">Последняя миля</label>
                  <TextField.Root
                    size="3"
                    value={priceParams.mila}
                    onChange={(e) =>
                      onChange({
                        ...priceParams,
                        mila: Number(e.target.value),
                      })
                    }
                    name="mila"
                    type="number"
                    min={0}
                  />
                </div>
              )}
            </>
          )}
          {([SHOP_IDENT.KATREN, SHOP_IDENT.SAMSON].includes(shop) ||
            ["default1", "default2", "with_sizes_1"].includes(calcIdent)) && (
            <>
              <Flex width="100%" gap="1">
                <div className={s.inputWrap}>
                  <label htmlFor="promo_profit">
                    Минимальная прибль для акций
                  </label>
                  <TextField.Root
                    size="3"
                    value={priceParams.promo_profit}
                    onChange={(e) =>
                      onChange({
                        ...priceParams,
                        promo_profit: Number(e.target.value),
                      })
                    }
                    name="promo_profit"
                    type="number"
                    min={0}
                  />
                </div>
                <div className={s.inputWrap}>
                  <label htmlFor="stale_profit">
                    Минимальная прибль для товаров на складах ВБ
                  </label>
                  <TextField.Root
                    size="3"
                    value={priceParams.stale_profit}
                    onChange={(e) =>
                      onChange({
                        ...priceParams,
                        stale_profit: Number(e.target.value),
                      })
                    }
                    name="stale_profit"
                    type="number"
                    min={0}
                  />
                </div>
              </Flex>
              <Flex width="100%" gap="1">
                <div className={s.inputWrap}>
                  <label htmlFor="promo_margin">Маржинальность для акций</label>
                  <TextField.Root
                    size="3"
                    value={priceParams.promo_margin}
                    onChange={(e) =>
                      onChange({
                        ...priceParams,
                        promo_margin: Number(e.target.value),
                      })
                    }
                    name="promo_margin"
                    type="number"
                    min={0}
                  />
                </div>
                <div className={s.inputWrap}>
                  <label htmlFor="stale_margin">
                    Маржинальность для товаров на складах ВБ
                  </label>
                  <TextField.Root
                    size="3"
                    value={priceParams.stale_margin}
                    onChange={(e) =>
                      onChange({
                        ...priceParams,
                        stale_margin: Number(e.target.value),
                      })
                    }
                    name="stale_margin"
                    type="number"
                    min={0}
                  />
                </div>
              </Flex>
            </>
          )}
        </div>
        <h5>Изменение параметров выставления остатков</h5>
        <Button
          color="indigo"
          variant="soft"
          onClick={() => {
            const newAmountParams = [...amountParams, { amount: 1, count: 1 }]
            onChange(priceParams, newAmountParams)
          }}
        >
          <PlusIcon /> добавить новые параметры
        </Button>
        <Box>
          {amountParams?.map((params, index) => {
            return (
              <Flex key={"amount_params_amount" + index} gap="2">
                <Box width="100%">
                  Если у дистребьютера больше
                  <TextField.Root
                    size="3"
                    value={params.amount}
                    onChange={(e) => {
                      const newAmountParams = amountParams.map((el, idx) => {
                        if (idx === index) {
                          return {
                            ...el,
                            amount: Number(e.target.value),
                          }
                        }
                        return el
                      })
                      onChange(priceParams, newAmountParams)
                    }}
                    name={"amount_params_amount" + index}
                    type="number"
                    min={1}
                  />
                </Box>
                <Box width="100%">
                  то ставим
                  <TextField.Root
                    size="3"
                    value={params.count}
                    onChange={(e) => {
                      const newAmountParams = amountParams.map((el, idx) => {
                        if (idx === index) {
                          return {
                            ...el,
                            count: Number(e.target.value),
                          }
                        }
                        return el
                      })
                      onChange(priceParams, newAmountParams)
                    }}
                    name={"amount_params_count" + index}
                    type="number"
                    min={1}
                  />
                </Box>
                <Box pt="3" style={{ alignSelf: "center" }}>
                  <Button
                    color="crimson"
                    variant="soft"
                    onClick={() => {
                      const newAmountParams = amountParams.filter(
                        (_, idx) => idx !== index,
                      )
                      onChange(priceParams, newAmountParams)
                    }}
                  >
                    <Cross1Icon />
                  </Button>
                </Box>
              </Flex>
            )
          })}
        </Box>

        <Box pt="4">
          <Button
            onClick={() => {
              onSave(priceParams, amountParams)
            }}
          >
            Сохранить
          </Button>
        </Box>
      </div>
      <div>
        <Calculator {...priceParams} shop={shop} />
      </div>
    </Box>
  )
}
